import { MutableRefObject, useCallback, useRef } from "react";

import isFunction from "lodash-es/isFunction";

interface ValueSetter<T> {
  (value: T): void;
  (setter: (previousValue: T) => T): void;
}

const useRefState = <T>(
  initialValue: T,
  rerender?: () => void
): [MutableRefObject<T>, ValueSetter<T>] => {
  const valueRef = useRef<T>(initialValue);
  const setValue: ValueSetter<T> = useCallback(
    (param: ((previousValue: T) => T) | T) => {
      if (isFunction(param)) {
        valueRef.current = param(valueRef.current);
      } else {
        valueRef.current = param;
      }
      rerender?.();
    },
    [rerender]
  );
  return [valueRef, setValue];
};

export default useRefState;
